import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useStores from "@hooks/useStores";

import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";

import { adjective as proAdjective } from "@language/provider";

const ContentFooter = () => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();
	return (
		<>
			<Divider light />

			{store.relatedArticles.length > 0 && (
				<Box bgcolor={"#fafafa"}>
					<Container maxWidth={false} className={classes.relatedBox}>
						<Box mb={20} mt={10}>
							<Box fontSize={{ xs: 28, sm: 30 }} fontWeight={700} mb={10}>
								Related articles
							</Box>
							<Grid container spacing={8}>
								{store.relatedArticles.map((article, i) => (
									<Grid item xs={12} sm={6} md={4} lg={3} key={`article-${i}`}>
										<Card
											variant={"outlined"}
											component={"article"}
											className={classes.cardBox}
										>
											<CardActionArea>
												<a href={article.url} target="_blank">
													<CardMedia
														component="img"
														className={classes.cardThumbnail}
														image={article.thumbnail?.cdnUrl}
														title={article.title}
														alt={article.name}
														loading={"lazy"}
														decoding="async"
													/>
													<CardContent className={` ${classes.cardContent}`}>
														<div className={classes.cardTitle}>
															{article.name}
														</div>
													</CardContent>
												</a>
											</CardActionArea>
										</Card>
									</Grid>
								))}
							</Grid>
						</Box>
					</Container>
				</Box>
			)}

			{store.popularCities.length > 0 && (
				<Container maxWidth={false} className={classes.relatedBox}>
					<div>
						<Box fontSize={{ xs: 28, sm: 30 }} fontWeight={700} mb={10} mt={10}>
							{`Find ${store.service?.phrase.toLowerCase()} in your area`}
						</Box>
						<Grid container spacing={4}>
							{store.popularCities.map((city) => (
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<Link
										color={"primary"}
										href={`${city.url}${store.service.url}/`}
									>
										{`${store.service?.phrase.ucFirst()} ${city.name.ucFirst()}`}
									</Link>
								</Grid>
							))}
						</Grid>
					</div>
				</Container>
			)}

			{(store.service || store.relatedServices.length > 0) && (
				<Container maxWidth={false} className={classes.relatedBox}>
					<Box mb={20}>
						<Box fontSize={{ xs: 28, sm: 30 }} fontWeight={700} mb={10}>
							{`Find ${proAdjective.plural} nearby`}
						</Box>
						<Grid container spacing={4}>
							{store.service && (
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<Link color={"primary"} href={store.service.url}>
										{`${store.service.phrase.ucFirst()} near me`}
									</Link>
								</Grid>
							)}
							{store.relatedServices.map((service) => (
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<Link color={"primary"} href={service.url}>
										{`${service.phrase.ucFirst()} near me`}
									</Link>
								</Grid>
							))}
						</Grid>
					</Box>
				</Container>
			)}
		</>
	);
};

ContentFooter.propTypes = {};
export default ContentFooter;
